<!-- TODO 使われていない -->
<template>
  <div id="Admin">
    <div class="vue-tree">
      <dd-tree
        class="item"
        :model="treeData">
      </dd-tree>
    </div>
    <button @click="onClickGo('00000000000000000021_20180620174742662')">Go</button>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import {API_URL} from '../constants/App'
import Tree from '../components/admin/Tree'
export default {
  name: 'Admin',
  components: {
    'dd-tree': Tree
  },
  data () {
    return {
      treeData: {
      }
    }
  },
  methods: {
    onClickGo: function (params) {
      axios.get(API_URL.BOM + '/' + params)
        .then(response => {
          console.log(JSON.stringify(response.data.data))
          this.treeData = response.data.data
        }).catch(error => {
          Api.handleError(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
body {
font-family: Menlo, Consolas, monospace;
color: #444;
}
#Admin{
width:12%;
}
.item {
cursor: pointer;
}
.bold {
font-weight: bold;
}
ul {
padding-left: 1em;
line-height: 1.5em;
list-style-type: dot;
}
.vue-tree li:first-child:before ,.vue-tree li:first-child:after{
border:0;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Admin.vue